import { LeafTab } from "./tabs.component.js";
customElements.define("leaf-tab", LeafTab);
export {
  LeafTab
};
//# sourceMappingURL=tabs.js.map
